import { render, staticRenderFns } from "./CategoryPages.vue?vue&type=template&id=121b7aa6&"
import script from "./CategoryPages.vue?vue&type=script&lang=js&"
export * from "./CategoryPages.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPages.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports